// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "移动互联网应用开发",
        "tec": "侯荣旭",
        "week": "1-8周",
        "add": "实训楼F座307信机"
      },
      {
        "sub": "劳动与创造",
        "tec": "李玉秀",
        "week": "18周",
        "add": "实训楼F座302信息"
      }
    ],
    [
      {
        "sub": "计算机游戏技术基础",
        "tec": "李玉秀",
        "week": "3-14周",
        "add": "实训楼F座307信机"
      },
      {
        "sub": "劳动与创造",
        "tec": "李玉秀",
        "week": "18周",
        "add": "实训楼F座302信息"
      }
    ],
    0,
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      }
    ],
    0
  ],
  "2": [
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-16周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "数字图像处理",
      "tec": "李玉秀",
      "week": "9-16周",
      "add": "实训楼F座307信机"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "人机交互设计",
      "tec": "孟轩羽",
      "week": "1-12周",
      "add": "实训F座210信机"
    },
    {
      "sub": "就业创业指导",
      "tec": "于天宇",
      "week": "1-5周",
      "add": "教学楼C座213教务"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "劳动与创造",
        "tec": "李玉秀",
        "week": "18周",
        "add": "实训楼F座302信息"
      }
    ],
    [
      {
        "sub": "移动互联网应用开发",
        "tec": "侯荣旭",
        "week": "1-8周",
        "add": "新型电力系统大楼212计算机房"
      },
      {
        "sub": "数字图像处理",
        "tec": "李玉秀",
        "week": "9-16周",
        "add": "实训楼F座307信机"
      },
      {
        "sub": "劳动与创造",
        "tec": "李玉秀",
        "week": "18周",
        "add": "实训楼F座302信息"
      }
    ],
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-16单周",
      "add": "实训楼F座302信息"
    },
    {
      "sub": "人机交互设计",
      "tec": "孟轩羽",
      "week": "1-12周",
      "add": "实训楼F座307信机"
    },
    {
      "sub": "计算机游戏技术基础",
      "tec": "李玉秀",
      "week": "3-14周",
      "add": "实训楼F座307信机"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
